<template lang="pug">
.invoices-styled-panel
  //- Header con título e ícono
  .d-flex.align-items-center.justify-content-between.tw-mb-3.tw-pb-2.tw-border-b.tw-border-gray-200
    .d-flex.align-items-center.tw-gap-2
      i.fa-solid.fa-file-invoice-dollar.tw-text-emerald-600
      span.tw-font-semibold.tw-text-gray-700 {{ $I18n.t('vue.payment_invoices_table_panel.title') }}
      span.tw-bg-emerald-100.tw-text-emerald-700.tw-px-2.tw-py-1.tw-rounded-full.tw-text-xs.tw-font-medium {{ items.length }}

  //- Tabla mejorada
  .table-responsive(v-if='!emptyItems')
    table.table.table-hover.invoices-styled-table
      thead
        tr
          th.tw-text-center(style="width: 70px;") {{ $I18n.t('vue.payment_invoices_table_panel.table_header_id') }}
          th(style="width: 100px;") {{ $I18n.t('vue.payment_invoices_table_panel.table_header_number') }}
          th.tw-text-center(style="width: 90px;") {{ $I18n.t('vue.payment_invoices_table_panel.table_header_status') }}
          th(style="width: 150px;") {{ $I18n.t('vue.payment_invoices_table_panel.table_header_vendor') }}
          th(style="width: 140px;") {{ $I18n.t('vue.payment_invoices_table_panel.table_header_customer') }}
          th(style="width: 160px;") {{ $I18n.t('vue.payment_invoices_table_panel.table_header_subsidary') }}
          th.tw-text-center(style="width: 100px;") {{ $I18n.t('vue.payment_invoices_table_panel.table_header_date_invoice') }}
          th.tw-text-right(style="width: 100px;") {{ $I18n.t('vue.payment_invoices_table_panel.table_header_amount') }}
          th.tw-text-center(style="width: 80px;") {{ $I18n.t('vue.payment_invoices_table_panel.table_header_porcent') }}
          th.tw-text-right(style="width: 120px;") {{ $I18n.t('vue.payment_invoices_table_panel.table_header_amount_with_credit_card') }}
          th.tw-text-center(style="width: 80px;") {{ $I18n.t('vue.payment_invoices_table_panel.table_header_cod') }}
          th.tw-text-center(style="width: 70px;") Actions
      tbody
        tr(v-for="(item, index) in items" :key="item.id")
          //- ID
          td.tw-text-center
            span.tw-font-mono.tw-text-sm.tw-font-medium.tw-text-gray-700 {{ item.id }}
          //- PO#
          td
            span.tw-text-sm(v-if="item.document_number") {{ item.document_number }}
            span.tw-text-gray-400.tw-text-xs(v-else) —
          //- Status
          td.tw-text-center
            span.tw-px-2.tw-py-1.tw-rounded-full.tw-text-xs.tw-font-medium(:class="getStatusClass(item.status)")
              i.tw-mr-1(:class="getStatusIcon(item.status)")
              | {{ $I18n.t('vue.states.'+item.status.toLowerCase()) }}
          //- Vendor
          td
            .d-flex.align-items-center.tw-gap-1(v-if="item.vendor_name")
              i.fa-solid.fa-truck.tw-text-gray-400.tw-text-xs
              a.tw-text-blue-600.tw-text-sm.tw-hover-underline(:href="item.vendor_path" v-if="item.vendor_path") {{ item.vendor_name }}
              span.tw-text-sm(v-else) {{ item.vendor_name }}
            div(v-else v-html="item.list_vendors_in_links")
          //- Customer
          td
            .d-flex.align-items-center.tw-gap-1(v-if="item.customer_name")
              i.fa-solid.fa-building.tw-text-gray-400.tw-text-xs
              a.tw-text-blue-600.tw-text-sm(:href="item.customer_path" v-if="item.customer_path") {{ item.customer_name }}
              span.tw-text-sm(v-else) {{ item.customer_name }}
            div(v-else v-html="item.list_customers_in_links")
          //- Restaurant
          td
            .d-flex.align-items-center.tw-gap-1(v-if="item.subsidary_name")
              i.fa-solid.fa-store.tw-text-gray-400.tw-text-xs
              a.tw-text-blue-600.tw-text-sm(:href="item.subsidary_path" v-if="item.subsidary_path") {{ item.subsidary_name }}
              span.tw-text-sm(v-else) {{ item.subsidary_name }}
            div(v-else v-html="item.list_subsidaries_in_links")
          //- Invoice Date
          td.tw-text-center
            .d-flex.align-items-center.justify-content-center.tw-gap-1
              i.fa-solid.fa-calendar.tw-text-gray-400.tw-text-xs
              span.tw-text-sm {{ item.locale_date }}
          //- Amount
          td.tw-text-right
            span.tw-font-mono.tw-text-sm.tw-font-medium {{ item.masked_amount }}
          //- Credit Card Fee %
          td.tw-text-center
            span.tw-px-2.tw-py-1.tw-rounded.tw-text-xs.tw-bg-gray-100.tw-text-gray-600(v-if="item.masked_porcent") {{ item.masked_porcent }}
            span.tw-text-gray-400.tw-text-xs(v-else) —
          //- Amount with Credit Card
          td.tw-text-right
            span.tw-font-mono.tw-text-sm.tw-font-semibold.tw-text-emerald-600 {{ item.masked_amount_with_credit_card }}
          //- Payment Term (COD)
          td.tw-text-center
            span.tw-px-2.tw-py-1.tw-rounded.tw-text-xs.tw-bg-blue-100.tw-text-blue-700(v-if="item.cod") {{ item.cod }}
            span.tw-text-gray-400.tw-text-xs(v-else) —
          //- Actions
          td.tw-text-center
            .d-flex.justify-content-center
              app-icon-link(
                data-kind="link",
                :href="order_path(item.id)"
                data-target="_blank"
                data-icon="fa-solid fa-eye",
                data-label="",
                :data-title="$I18n.t('vue.payment_invoices_table_panel.view_invoice')"
              )

  //- Estado vacío mejorado
  .tw-text-center.tw-py-8(v-if='emptyItems')
    .tw-w-16.tw-h-16.tw-bg-emerald-100.tw-rounded-full.d-flex.align-items-center.justify-content-center.tw-mx-auto.tw-mb-3
      i.fa-solid.fa-file-invoice-dollar.tw-text-emerald-400.tw-text-2xl
    p.tw-text-gray-500.tw-mb-0 {{ $I18n.t('vue.payment_invoices_table_panel.empty_items') }}
</template>
<script>
import CoreComponents from "../core";
const { BackendRoutes } = require("app/services");

export default {
  components:{
    "app-icon-link": CoreComponents.AppIconLink,
  },
  props:{
    dataItems: String,
  },
  data: function(){
    return {
      record:{
      },
      items: JSON.parse(this.dataItems),
      labels:{
      }
    }
  },
  computed:{
    emptyItems: function(){
      return this.items.length === 0;
    }
  },
  methods:{
    getStatusClass: function(status) {
      const classes = {
        'PAID': 'tw-bg-green-100 tw-text-green-700',
        'UNPAID': 'tw-bg-yellow-100 tw-text-yellow-700',
        'PARTIAL': 'tw-bg-orange-100 tw-text-orange-700',
        'CANCELED': 'tw-bg-red-100 tw-text-red-700',
        'DRAFT': 'tw-bg-gray-100 tw-text-gray-700'
      };
      return classes[status] || 'tw-bg-gray-100 tw-text-gray-600';
    },
    getStatusIcon: function(status) {
      const icons = {
        'PAID': 'fa-solid fa-check-circle',
        'UNPAID': 'fa-solid fa-clock',
        'PARTIAL': 'fa-solid fa-adjust',
        'CANCELED': 'fa-solid fa-times-circle',
        'DRAFT': 'fa-solid fa-file'
      };
      return icons[status] || 'fa-solid fa-circle';
    },
    order_path: function (invoice_id) {
      return BackendRoutes.invoice_path(invoice_id);
    }
  }
}
</script>

<style scoped>
.invoices-styled-panel {
  padding: 1rem;
  background: white;
  border-radius: 0.375rem;
}

.invoices-styled-table {
  font-size: 0.85rem;
  margin-bottom: 0;
}

.invoices-styled-table thead th {
  white-space: nowrap;
  vertical-align: middle;
  padding: 0.5rem 0.75rem;
  background-color: #f8f9fa;
  border-bottom: 2px solid #dee2e6;
  font-weight: 600;
  color: #495057;
}

.invoices-styled-table tbody td {
  vertical-align: middle;
  padding: 0.5rem 0.6rem;
}

.invoices-styled-table tbody tr:hover {
  background-color: rgba(16, 185, 129, 0.05);
}

/* Override list styles from v-html */
.invoices-styled-table :deep(.list-group) {
  margin: 0;
  padding: 0;
  list-style: none;
}

.invoices-styled-table :deep(.list-group li) {
  padding: 0;
}

.invoices-styled-table :deep(.index-table-action-link) {
  font-size: 0.85rem;
}

.invoices-styled-table :deep(.index-table-action-link a) {
  color: #2563eb;
  text-decoration: none;
}

.invoices-styled-table :deep(.index-table-action-link a:hover) {
  text-decoration: underline;
}
</style>
